export const endpoints = {
    loginWithIdpToken: `${process.env.API_URL}/v1/LoginWithIDPToken`,
    apiToken: `${process.env.API_URL}/v1/ApiTriggerToken`,
    apiTrigger: `${process.env.API_URL}/v1/ApiTrigger`,
    createUser: `${process.env.API_URL}/v1/CreateUser`,
    getFeatureFlag: `${process.env.API_URL}/featureflag/evaluate`,
    triggerInvite: `${process.env.API_URL}/v1/TriggerInvitation`
};
